import React from 'react'

export default function LoadingSpinner() {
  return (
    <div className="spinner-border text-light me-2" style={{height:'20px', width:'20px'}} role="status"></div>
  )
}
